export const WITHDRAWAL_WINDOW_IN_DAYS = 14;
export const STUDENTS_TEAM_EMAIL = "students@normasteaching.com";

export function isRequestedWithinWithdrawalWindow(
  requestedAtUtc: Date,
  withdrawalDeadlineUtc: string,
): boolean {
  return requestedAtUtc.getTime() <= new Date(withdrawalDeadlineUtc).getTime();
}

export function describeWithdrawalWindow(
  isWithinWithdrawalWindow: boolean,
): string {
  return isWithinWithdrawalWindow
    ? `Legacy (entro ${WITHDRAWAL_WINDOW_IN_DAYS} giorni dall'acquisto)`
    : `Extra legacy (oltre ${WITHDRAWAL_WINDOW_IN_DAYS} giorni dall'acquisto)`;
}
